import {ClientViewModel} from './client.view-model';
import {Utils} from '@shared/utilities/utils';
import {Injectable} from '@angular/core';
import {ClientDTO} from '@dto/entities/clients-dto.model';
import {IconViewModel} from '@components/ui/table-template/models/icon-view-model';
import {IconSize} from '@components/ui/table-template/enums/icon-size.enum';
import {APP_ENTITY} from '../../config/app-urls';
import {IconColour} from '@components/ui/table-template/enums/icon-colour.enum';

@Injectable({
  providedIn: 'root'
})
export class ClientConverterService {

  public convert(clients: ClientDTO[]): ClientViewModel[] {
    return clients.map(c => this.convertSingle(c));
  }

  private convertSingle(client: ClientDTO): ClientViewModel {

    const iconImageUrl = Utils.getClientIconSource(client.BaseType);
    const iconTitle = Utils.getClientIconTitle(client.BaseType);
    const detailsRouterLinkCommands = APP_ENTITY.toRouterLinkCommands(client.Code);

    return {
      icon: new IconViewModel(iconImageUrl, iconTitle, 0, IconSize.Medium, IconColour.IconPrimary),
      name: client.Name,
      detailsRouterLinkCommands: detailsRouterLinkCommands,
      type: client.Type,
      jurisdiction: client.Jurisdiction,
      countryOfIncorporation: client.CountryOfIncorporation,
      administrativeOffice: client.AdministrativeOffice,
      registeredOffice: client.RegisteredOffice
    };
  }
}
